import { useTranslation } from 'react-i18next';
import React, { FC, useMemo } from 'react';
import { AiOutlineTeam } from 'react-icons/ai';

import Carosuel from '@/atoms/image-slider';
import { Unit } from '@core/booking/booking.types';

function cloudinaryUrl(url: string, width: number): string {
  if (!url || !url.includes('res.cloudinary.com')) return url;
  const transforms = `q_auto:best,f_auto,w_${width},c_fill,dpr_2.0`;
  return url.replace('/upload/', `/upload/${transforms}/`);
}

interface MeetingRoomCardProps {
  room: Unit;
  locationName: string;
  locationAddress: string;
  onClick: () => void;
}

const MeetingRoomCard: FC<MeetingRoomCardProps> = ({ room, locationName, locationAddress, onClick }) => {
  const { t } = useTranslation();
  const images = useMemo(() => {
    return room.image_link ? [{ url: cloudinaryUrl(room.image_link, 600) }] : [{ url: '/placeholder.webp' }];
  }, [room.image_link]);

  return (
    <div
      onClick={onClick}
      className="cursor-pointer rounded-xl shadow-md hover:shadow-xl transition-all bg-white overflow-hidden w-full"
    >
      <Carosuel showThumbs={false} height={180} images={images} isImagesUnOptimized />
      <div className="p-4">
        <h3 className="text-lg font-bold mb-1 m-0" style={{ color: '#404D61' }}>
          {room.name}
        </h3>
        <p className="text-sm mb-1 m-0" style={{ color: '#707070' }}>
          {locationName}
        </p>
        <p className="text-xs mb-2 m-0" style={{ color: '#999' }}>
          {locationAddress}
        </p>
        <div className="flex items-center" style={{ color: 'var(--main)' }}>
          <AiOutlineTeam className="mr-1" size={16} />
          <span className="text-sm font-medium">
            {t('landing.upToPeople', { count: Number(room.max_people_number) })}
          </span>
        </div>
      </div>
    </div>
  );
};

export default MeetingRoomCard;
